export const translatedPaymentFrequencies = [
    {
        name: "MONTHLY",
        description: "Mensal"
    },
    {
        name: "SEMI_ANNUALLY",
        description: "Semestral"
    },
    {
        name: "ANNUALLY",
        description: "Anual"
    },
    {
        name: "QUARTERLY",
        description: "Trimestral"
    }
]